import React, { forwardRef, memo } from "react";
import clsx from "clsx";
import styles from "./Toggle.module.scss";
import Text from "./Text";

export type Props = {
    firstOption: string;
    secondOption: string;
    firstOptionSelected: boolean;
    className?: string;
    variant?: "default";
    hideText?: boolean;
} & React.HTMLProps<HTMLAnchorElement | HTMLButtonElement>;

const Toggle = forwardRef<HTMLButtonElement, Props>((props, ref) => {
    const {
        variant = "default",
        className,
        hideText = false,
        firstOption,
        secondOption,
        firstOptionSelected,
        ...rest
    } = props;

    return (
        <div className={clsx(styles.wrapper, className)}>
            {React.createElement(
                "button",
                {
                    ...rest,
                    ref,
                    type: "button",
                    className: styles[variant],
                    "aria-label": firstOptionSelected ? firstOption : secondOption,
                },
                <span className={clsx(styles.toggle, !firstOptionSelected && styles["second-option"])} />,
            )}
            {!hideText && (
                <div className={styles["text-wrapper"]}>
                    <Text variant="apheleia-body">{firstOption}</Text>
                    <Text variant="apheleia-body">{secondOption}</Text>
                </div>
            )}
        </div>
    );
});

Toggle.displayName = "Toggle";
export default memo(Toggle);
